<template>
    <div id="editTicket">
        <el-alert
            v-if="loginError"
            :description="loginError"
            class="fin-mb-3"
            type="error"
        />
        <el-card
            class="fin-flex fin-justify-end fin-items-center fin-absolute -fin-bottom-6 fin-z-20 fin-bg-white fin-block fin-border-t-2 fin-px-3 fin-py-3 fin-right-0"
            :style="!isTenant ? `width: ${footerWidth}px` : 'width: 100%'"
        >
            <div class="fin-flex fin-justify-between fin-items-center fin-justify-self-end">
                <div class="fin-flex fin-space-x-4 fin-items-center">
                    <el-dropdown class="fin-p-2" v-if="!isTenant">
                        <el-button type="success" :loading="loading" class="fin-capitalize">
                            Login as
                            <i class="el-icon-arrow-down el-icon--right"></i>
                        </el-button>
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item @click.native="loginAs('master')">Master</el-dropdown-item>
                            <el-dropdown-item @click.native="loginAs('user')">User</el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>

                    <el-dropdown v-if="!isTenant">
                        <el-button type="primary" :loading="loading" class="fin-capitalize"
                                   :disabled="!_.isNull(_.get(editForm, 'deleted_at', null))">
                            Github Issue
                            <i class="el-icon-arrow-down el-icon--right"></i>
                        </el-button>
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item
                                v-for="githubMember in githubMembers"
                                :key="_.get(githubMember, 'login')">
                                <el-dropdown-item @click.native="githubIssue(_.get(githubMember, 'login'))"
                                                  class="fin-flex fin-items-center fin-space-x-3">
                                    <img :src="_.get(githubMember, 'avatar_url')"
                                         class="fin-h-8 fin-w-8 fin-rounded-full"/>
                                    <span>{{ _.get(githubMember, 'login') }}</span>
                                </el-dropdown-item>
                            </el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>

                    <el-dropdown class="fin-p-2">
                        <el-button type="success" :loading="loading" class="fin-capitalize">
                            Update Ticket as {{ updateStatus }}
                            <i class="el-icon-arrow-down el-icon--right"></i>
                        </el-button>
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item @click.native="save('new')" v-if="isTenant">Update</el-dropdown-item>
                            <el-dropdown-item
                                @click.native="save('open')"
                                :disabled="
                                    !_.isNull(_.get(editForm, 'deleted_at', null)) ||
                                    _.get(editForm, 'status') === 'closed' ||
                                    isTenant
                                "
                            >
                                Open
                            </el-dropdown-item>
                            <el-dropdown-item
                                @click.native="save(_.get(editForm, 'status'), true)"
                                :disabled="
                                    !_.isNull(_.get(editForm, 'deleted_at', null)) ||
                                    _.get(editForm, 'status') === 'closed'
                                "
                            >
                                Reply
                            </el-dropdown-item>
                            <el-dropdown-item
                                @click.native="save('re-open')"
                                v-if="_.get(editForm, 'deleted_at') || _.get(editForm, 'status') === 'closed'"
                            >
                                Re-Open
                            </el-dropdown-item>
                            <el-dropdown-item
                                @click.native="save('inprogress')"
                                :disabled="
                                    !_.isNull(_.get(editForm, 'deleted_at', null)) ||
                                    _.get(editForm, 'status') === 'closed' ||
                                    isTenant
                                "
                            >
                                Inprogress
                            </el-dropdown-item>
                            <el-dropdown-item
                                @click.native="save('pending')"
                                :disabled="
                                    !_.isNull(_.get(editForm, 'deleted_at', null)) ||
                                    _.get(editForm, 'status') === 'closed' ||
                                    isTenant
                                "
                            >
                                Pending
                            </el-dropdown-item>
                            <el-dropdown-item
                                @click.native="save('suspended')"
                                :disabled="
                                    !_.isNull(_.get(editForm, 'deleted_at', null)) ||
                                    _.get(editForm, 'status') === 'closed' ||
                                    isTenant
                                "
                            >
                                Suspended
                            </el-dropdown-item>
                            <el-dropdown-item
                                @click.native="save('closed')"
                                :disabled="
                                    !_.isNull(_.get(editForm, 'deleted_at', null)) ||
                                    _.get(editForm, 'status') === 'closed' ||
                                    isTenant
                                "
                            >
                                Closed
                            </el-dropdown-item>
                            <el-dropdown-item
                                @click.native="save('solved')"
                                :disabled="
                                    !_.isNull(_.get(editForm, 'deleted_at', null)) ||
                                    _.get(editForm, 'status') === 'closed' ||
                                    isTenant
                                "
                            >
                                Solved
                            </el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                </div>
            </div>
        </el-card>

        <el-card :class="isTenant ? 'fin-mx-10 fin-mt-5' : ''">
            <div class="fin-flex fin-justify-between fin-items-center fin-sticky" slot="header">
                <div class="fin-space-y-2">
                    <h1 class="fin-font-extrabold fin-text-2xl fin-text-blue-800 fin-mb-2">{{ editForm.subject }}</h1>
                    <div v-if="editForm.application_id">
                        <span class="fin-font-semibold fin-text-lg">{{ editForm.application_id }}</span>
                    </div>

                    <div>
                        <small>
                            <i class="fas fa-clock"></i>
                            <span class="fin-font-semibold">Created Date</span>
                            <span>{{ formatDate(_.get(editForm, 'created_at')) }}</span>
                        </small>
                    </div>

                    <a
                        v-if="!isTenant && _.get(editForm, 'github_issue_url')"
                        :href="_.get(editForm, 'github_issue_url')"
                        target="_blank"
                        class="fin-mt-2"
                    >
                        {{ _.get(editForm, 'github_issue_url') }}
                    </a>
                </div>

                <el-button type="primary" @click="backToTickets" id="Attachments">
                    <i class="el-icon-arrow-left el-icon-left fin-mr-3"></i>
                    Back To Tickets
                </el-button>
            </div>

            <div class="fin-flex fin-space-x-8 fin-relative">
                <el-form ref="form" :model="editForm" :rules="rules" label-width="120px" label-position="top"
                         class="fin-w-2/5">
                    <el-form-item label="Tenants & Teams" prop="tenantsTeams" v-if="!isTenant">
                        <el-cascader
                            v-model="tenantsTeams"
                            :options="filters.tenantsTeamsBrokers"
                            :show-all-levels="true"
                            :props="{ checkStrictly: true }"
                            collapse-tags
                            clearable
                            filterable
                            :filter-method="(n, k) => n.getText(false, null).toLowerCase().indexOf(k.toLowerCase()) >= 0"
                            popper-class="custom-cascader"
                            :style="{ width: '100%' }"
                        ></el-cascader>
                    </el-form-item>

                    <el-form-item label="CCs" prop="CCs" v-if="!isTenant">
                        <el-select
                            class="fin-w-full"
                            v-model="editForm.ccs"
                            multiple
                            filterable
                            remote
                            reserve-keyword
                            placeholder="Please enter a keyword"
                            :remote-method="remoteMethod"
                            :loading="loading"
                        >
                            <el-option
                                v-for="(item, key) in ccsOptions"
                                :key="key"
                                :label="item.first_name + ' ' + item.last_name"
                                :value="item.email"
                            >
                                <div class="fin-flex fin-justify-between fin-items-center">
                                    <p>
                                        {{ item.first_name + ' ' + item.last_name }}
                                        <span v-if="_.get(item, 'roles.0.name')">({{
                                                _.get(item, 'roles.0.name')
                                            }})</span>
                                    </p>
                                    <p class="fin-font-semibold">{{ item.email }}</p>
                                </div>
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="Requester" prop="requester">
                        <el-select class="w-100" v-model="editForm.user_id" clearable>
                            <el-option
                                v-for="(requester, key) in requesters"
                                :key="requester.id"
                                :label="_.get(requester, 'full_name')"
                                :value="requester.id"
                            >
                                <div class="fin-flex fin-justify-between fin-items-center">
                                    <p>{{ _.get(requester, 'full_name') }}</p>
                                    <p class="fin-font-semibold">{{ _.get(requester, 'email') }}</p>
                                </div>
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="Assignee" prop="assignee_id" v-if="!isTenant">
                        <el-select class="w-100" v-model="editForm.assignee_id" clearable>
                            <el-option
                                v-for="(assignee, key) in assignees"
                                :key="assignee.id"
                                :label="_.get(assignee, 'full_name')"
                                :value="assignee.id"
                            ></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="Priority" prop="priority" v-if="!isTenant">
                        <el-select class="w-100" v-model="editForm.priority" clearable>
                            <el-option
                                v-for="(priorityOption, key) in priorityOptions"
                                :key="key"
                                :label="priorityOption"
                                :value="key"
                            ></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="Category" prop="category">
                        <el-select class="w-100" v-model="editForm.category" clearable>
                            <el-option
                                v-for="(categoryOption, key) in mergedCategoryOptions()"
                                :key="key"
                                :label="categoryOption"
                                :value="categoryOption"
                            ></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="Content" prop="body">

                        <div v-if="_.size(this.ticketAttachmentData.data) > 0" @click="jumpTo('Attachments')">
                            <el-alert
                                title="Click To View Attachments"
                                type="warning"
                                class="mb-2 fin-cursor-pointer"/>
                        </div>

                        <Quill v-model.sync="editForm.body"></Quill>
                    </el-form-item>

                </el-form>

                <div class="fin-w-3/5">
                    <el-collapse v-model="activeAccordian" class="fin-w-full">
                        <el-collapse-item name="1">
                            <template slot="title">
                                <div class="fin-text-blue-700">
                                    <label>Attachments</label>
                                    <el-badge
                                        class="fin-absolute -fin-top-2"
                                        :value="_.size(this.ticketAttachmentData.data)">
                                    </el-badge>
                                </div>
                            </template>

                            <div class="flex flex-wrap">
                                <a class="display: flex mb-2"
                                   v-for="(ticketAttachment, index) in ticketAttachmentData.data"
                                   @click.prevent="downloadAttachemnt(_.get(ticketAttachment, 'file_name'),'/api/ticket-attachments/' + ticketAttachment.id + '/download')">
                                    <div class="border-design ml-2 p-2">
                                        <img :src=fileArray[index] class="ml-2 mr-2" style="width: 20px"/>
                                        <div class="ticket-attachment">
                                            {{ _.get(ticketAttachment, 'file_name').substring(11) }}
                                        </div>
                                    </div>
                                </a>
                            </div>

                            <pagination
                                class="fin-mt-3"
                                v-show="_.get(ticketAttachmentData, 'total') > 0"
                                :total="_.get(ticketAttachmentData, 'total')"
                                :page.sync="_.get(ticketAttachmentData, 'current_page')"
                                :limit.sync="_.get(ticketAttachmentData, 'per_page')"
                                @pagination="ticketAttachments"
                            />
                        </el-collapse-item>
                        <el-collapse-item name="2">
                            <template slot="title">
                                <div class="fin-text-blue-700">
                                    <label>Messages</label>
                                </div>
                            </template>

                            <div class="fin-mb-4">
                                <label class="fin-block fin-mb-2 fin-text-sm fin-font-medium fin-text-gray-900"
                                       for="ticket_multiple_files">
                                    Include Attachments ?
                                </label>

                                <div class="fin-flex fin-items-center fin-justify-between">
                                    <el-upload
                                        class="upload-demo"
                                        action="https://jsonplaceholder.typicode.com/posts/"
                                        :on-change="onChangeAttachments"
                                        :on-remove="removeChangeAttachments"
                                        :file-list="files"
                                        :auto-upload="false"
                                        multiple>
                                        <el-button size="small" type="primary">Click to upload</el-button>

                                        <div slot="tip" class="el-upload__tip">
                                            JPG, JPEG, PNG, CSV, DOC, DOCX, XLX, XLSX, or PDF (MAX. 10Mb).
                                        </div>
                                    </el-upload>

                                    <el-button type="primary"
                                               icon="el-icon-upload"
                                               @click.prevent="uploadAttachments"
                                               :disabled="_.isEmpty(attachments)"></el-button>
                                </div>
                            </div>

                            <el-tabs v-model="activeReplyMessageTab">
                                <el-tab-pane label="Public Conversation" name="public">
                                    <Quill
                                        ref="publicEditor"
                                        v-model="replyPublic">
                                    </Quill>

                                    <div class="fin-mt-3 fin-flex fin-justify-end">
                                        <el-button
                                            type="primary"
                                            @click="replyConvo"
                                            :disabled="!_.isNull(_.get(editForm, 'deleted_at', null)) || _.isEmpty(reply.body) || replyLoading"
                                            :loading="replyLoading"
                                        >
                                            Reply
                                        </el-button>
                                    </div>
                                </el-tab-pane>
                                <el-tab-pane label="Internal Notes" name="internal" v-if="!isTenant">
                                    <Quill
                                        ref="internalEditor"
                                        v-model="internalConvo"></Quill>

                                    <div class="fin-mt-3 fin-flex fin-justify-end">
                                        <el-button
                                            type="primary"
                                            @click="saveInternalNote"
                                            :disabled="!_.isNull(_.get(editForm, 'deleted_at', null)) || _.isEmpty(notes.body) || replyLoading"
                                            :loading="replyLoading"
                                        >
                                            Save
                                        </el-button>
                                    </div>
                                </el-tab-pane>
                            </el-tabs>
                        </el-collapse-item>
                        <el-collapse-item name="3" class="fin-overflow-y-clip fin-h-1/2">
                            <template slot="title">
                                <div class="fin-text-blue-700 fin-flex fin-item-center fin-space-x-2">
                                    <label>Conversations</label>
                                    <span>{{ _.sum([conversationCount, notesCount]) }}</span>
                                </div>
                            </template>

                            <el-tabs v-model="activeReplyConversationTab" @tab-click="handleConversationTabClick">
                                <el-tab-pane :label="'Public'" name="public">
                                    <div v-for="conversation in conversations">
                                        <div class="fin-flex fin-flex-col fin-py-3">
                                            <label class="fin-flex fin-flex-col">
                                                <div class="fin-flex fin-justify-between fin-items-center">
                                                    {{ _.get(conversation, 'name') }}

                                                    <div
                                                        v-if="_.get(conversation, 'ticket_parent_id')"
                                                        class="fin-p-1 fin-rounded fin-bg-amber-300"
                                                    >
                                                        <small class="fin-font-semibold">
                                                            Merged from Ticket {{ _.get(conversation, 'ticket_id') }}
                                                        </small>
                                                    </div>
                                                </div>

                                                <small class="fin-mt-1">
                                                    <i class="fas fa-clock"></i>
                                                    {{ formatDate(_.get(conversation, 'created_at')) }}
                                                </small>
                                            </label>

                                            <span class="fin-mt-1" v-html="_.get(conversation, 'conversation')"></span>
                                        </div>
                                        <el-divider></el-divider>
                                    </div>

                                    <pagination
                                        class="fin-mt-3"
                                        v-show="_.get(collection, 'total') > 0"
                                        :total="_.get(collection, 'total')"
                                        :page.sync="_.get(collection, 'current_page')"
                                        :limit.sync="_.get(collection, 'per_page')"
                                        @pagination="getConvo"
                                    />
                                </el-tab-pane>
                                <el-tab-pane label="Internal" name="internal" v-if="!isTenant">
                                    <div v-for="internalNote in internalNotes">
                                        <div
                                            v-if="_.get(internalNote, 'tenant_parent_id')"
                                            class="fin-p-2 fin-rounded fin-my-2 fin-bg-amber-400"
                                        >
                                            <span>Merged from {{ _.get(internalNote, 'tenant_id') }}</span>
                                        </div>

                                        <div class="fin-flex fin-flex-col fin-py-3">
                                            <label class="fin-flex fin-flex-col">
                                                {{ _.get(internalNote, 'name') }}
                                                <small class="fin-mt-1">
                                                    <i class="fas fa-clock"></i>
                                                    {{ formatDate(_.get(internalNote, 'created_at')) }}
                                                </small>
                                            </label>

                                            <span class="fin-mt-1" v-html="_.get(internalNote, 'note')"></span>
                                        </div>
                                        <el-divider></el-divider>
                                    </div>

                                    <pagination
                                        class="fin-mt-3"
                                        v-show="_.get(collectionNotes, 'total') > 0"
                                        :total="_.get(collectionNotes, 'total')"
                                        :page.sync="_.get(collectionNotes, 'current_page')"
                                        :limit.sync="_.get(collectionNotes, 'per_page')"
                                        @pagination="getConvo"
                                    />
                                </el-tab-pane>
                            </el-tabs>
                        </el-collapse-item>
                    </el-collapse>
                </div>
            </div>
        </el-card>
    </div>
</template>

<script>
import Pagination from '@shared/components/pagination'
import XModal from '@shared/components/modal/Modal.vue'
import Quill from '@shared/components/TextEditor/Quill'
import moment from 'moment'
import { Octokit, App } from 'octokit'
import { createAppAuth } from '@octokit/auth-app'

export default {
    name: 'EditTicket',
    components: {
        XModal,
        Quill,
        Pagination,
    },
    props: {
        user: {
            type: [Object],
            default: null,
            required: false,
        },
        ticket: {
            type: [Object],
            default: null,
            required: false,
        },
        githubKey: {
            type: String,
            required: true,
        },
        priorityOptions: {
            required: true,
            type: [Array, Object],
        },
        categoryOptions: {
            required: true,
            type: [Array, Object],
        },
        adminCategoryOptions: {
            required: false,
            type: [Array, Object],
        },
        tenant: {
            required: false,
            default: null,
        },
        currentTeamId: {
            required: false,
            default: null,
        },
        isTenant: {
            required: false,
            default: false,
        },
        hasPermissions: {
            required: false,
            default: null,
        },
        masterHasPermissions: {
            required: false,
            default: false,
        }
    },
    data () {
        return {
            editForm: {},
            valueConvo: '',
            valueInternal: '',
            reply: {
                body: null
            },
            notes: {
                body: null
            },
            rules: {
                category: [{ required: true, message: 'Category is required' }],
                subject: [{ required: true, message: 'Subject is required' }],
                content: [{ required: true, message: 'Content is required' }],
            },
            assignees: [],
            requesters: [],
            loading: false,
            selectedAssignee: null,
            selectedRequester: null,
            internalNotes: [],
            conversations: [],
            collection: [],
            collectionNotes: [],
            activeAccordian: ['2', '3'],
            updateStatus: '',
            activeReplyMessageTab: 'public',
            activeReplyConversationTab: 'public',
            conversationCount: 0,
            notesCount: 0,
            githubToken: null,
            githubMembers: [],
            tenantsTeamsBrokers: [],
            tenantsTeams: [],
            ccsLists: [],
            ccsOptions: [],
            loginError: '',
            footerWidth: window.innerWidth - 200,
            replyLoading: false,
            files: [],
            attachments: [],
            ticketAttachmentData: [],
            fileNames: [],
            fileArray: []
        }
    },
    computed: {
        filters () {
            if (this.tenantsTeamsBrokers) {
                const data = {
                    tenantsTeamsBrokers: this.tenantsTeamsBrokers.map((tenantsTeamsBroker) => {
                        let children = tenantsTeamsBroker.teams.map((team) => {
                            return { value: team.id, label: team.name, children }
                        })
                        if (children.length === 0) children = [{ value: 'All Teams', label: 'All Teams' }]
                        return { value: tenantsTeamsBroker.id, label: tenantsTeamsBroker.name, children }
                    }),
                }

                // Handle single selects, if selected they should clear all other selections and mark other options as disabled
                Object.keys(data).forEach((key) => {
                    data[key]
                        .filter((e) => e.singleSelect)
                        .forEach((e) => {
                            const value = e.value
                            const isSelected = _.get(this.form, key, []).includes(value)
                            if (isSelected) {
                                // Clear other selections
                                this.form[key] = this.form[key].filter((e) => e === value)
                                // Disable other options
                                data[key] = data[key].filter((e) =>
                                    Object.assign(e, { disabled: e.value === value ? false : true })
                                )
                            }
                        })
                })

                return data
            } else {
                return {}
            }
        },
        isApi () {
            return this.isTenant ? this.$tenant : this.$admin
        },
        replyPublic: {
            get () {
                return this.valueConvo
            },
            set (val) {
                this.reply.body = val

                return this.$emit('update:valueConvo', val)
            }
        },
        internalConvo: {
            get () {
                return this.valueInternal
            },
            set (val) {
                this.notes.body = val

                return this.$emit('update:valueInternal', val)
            }
        }
    },
    watch: {
        'ticket.inline_attachment_contents': {
            handler (val) {
                if (_.size(val)) {
                    val.map(attachment => {
                        if (_.get(attachment, 'path')) {
                            let contentType = _.get(attachment, 'contentType')
                            let contentId = _.get(attachment, 'contentId')
                            let contentBytes = _.get(attachment, 'contentBytes')
                            let inlineImageSrc = `data:${contentType};base64,${contentBytes}`

                            if (this.ticket.body.indexOf(`cid:${contentId}`) !== false) {
                                this.ticket.body = this.ticket.body.replace(`cid:${contentId}`, inlineImageSrc)
                            }
                        }
                    })
                }
            },
            immediate: true
        },
        ticketAttachmentData: {
            handler (val) {
                if (_.size(val.data) <= 4) {
                    this.activeAccordian.push('1')
                }
            },
            immediate: true
        },
        ticket: {
            handler (val) {
                if (val) {
                    this.editForm = val
                    if (_.get(val, 'tenant') || _.get(val, 'team') || _.get(val, 'user_id')) {
                        this.editForm.tenantsTeamsBrokers = [_.get(val, 'tenant'), _.get(val, 'team'), _.get(val, 'user_id')]
                        if (_.get(val, 'tenant') && _.get(val, 'team')) {
                            this.tenantsTeams = [_.get(val, 'tenant'), _.get(val, 'team')]
                        } else if (_.get(val, 'tenant')) {
                            this.tenantsTeams = [_.get(val, 'tenant')]
                        }
                    }
                }
            },
            immediate: true,
            deep: true,
        },
        'editForm.assignee_id': {
            handler (val) {
                if (val && !_.isEmpty(this.assignees)) {
                    this.selectedAssignee = _.find(this.assignees, { id: val })
                        ? _.find(this.assignees, { id: val })
                        : _.find(this.assignees, { full_name: _.get(this.editForm, 'assignee') })
                }
            },
            immediate: true,
            deep: true,
        },
        'editForm.user_id': {
            handler (val) {
                if (val && !_.isEmpty(this.requesters)) {
                    this.selectedRequester = _.find(this.requesters, { id: val })
                        ? _.find(this.requesters, { id: val })
                        : _.find(this.requesters, { full_name: _.get(this.editForm, 'requester') })
                }
            },
            immediate: true,
            deep: true,
        },
        githubToken: {
            handler (val) {
                if (val && !this.isTenant) {
                    this.getGithubMembers(val)
                }
            },
            immediate: true,
            deep: true,
        },
        isTenant: {
            handler (val) {
                if (!val) {
                    const newRules = { assignee_id: [{ required: true, message: 'Assignee is required' }] }
                    this.rules = { ...this.rules, ...newRules }
                }
            },
            immediate: true,
            deep: true,
        },
        tenantsTeams: {
            handler (val) {
                if (val) {
                    this.editForm.tenantsTeamsBrokers = val

                    this.getRequesters(val[0])
                }
            },
            immediate: true,
            deep: true,
        },
    },
    mounted () {
        this.getAssignees()
        this.getTenantTeamBrokers()
        this.getConvo()
        this.getInternalNotes()
        this.getRequesters()
        this.getGithubToken()
        this.ticketAttachments()

        if (!this.isTenant) {
            this.remoteMethod(_.get(this.ticket, 'ccs'))
        }

        window.addEventListener('load', this.myEventHandler)
        window.addEventListener('resize', this.myEventHandler)
    },
    created () {
        window.addEventListener('resize', this.myEventHandler)
        window.addEventListener('load', this.myEventHandler)
    },
    beforeDestroy () {
        window.removeEventListener('resize', this.myEventHandler)
        window.removeEventListener('load', this.myEventHandler)
    },
    updated () {
    },
    activated () {
    },
    methods: {
        fileExtension () {
            const fileName = this.ticketAttachmentData.data
            fileName.forEach((file_name) => {
                let filterName = file_name.file_name.split('.').pop()
                if (filterName === 'pdf') {
                    this.fileArray.push('data:image/png;base64,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')

                } else if (filterName === 'doc' || filterName === 'docx') {
                    this.fileArray.push('data:image/png;base64,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')

                } else if (filterName === 'xls' || filterName === 'xlsx') {
                    this.fileArray.push('data:image/png;base64,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')

                } else {
                    this.fileArray.push('data:image/png;base64,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')
                }
            })
        },

        jumpTo (target) {
            document.getElementById(target).scrollIntoView({
                top: -100,
                behavior: 'smooth'
            })
            this.activeAccordian.push('1')
        },
        mergedCategoryOptions () {
            if (this.hasPermissions || this.masterHasPermissions) {
                return _.merge(this.categoryOptions, this.adminCategoryOptions)
            } else {
                return this.categoryOptions
            }
        },
        myEventHandler (e) {
            this.footerWidth = window.innerWidth - 200
        },
        backToTickets () {
            if (this.isTenant) {
                window.location = `/admin/account`
            } else {
                window.location = `/admin/ticket`
            }
        },
        remoteMethod (query) {
            if (query !== '') {
                this.loading = true
                setTimeout(() => {
                    this.loading = false

                    this.isApi
                        .get(`/api/tickets/search-ticket-ccs`, {
                            params: {
                                ccsQuery: query,
                                tenant: _.get(
                                    this.editForm,
                                    'tenantsTeamsBrokers.0',
                                    _.get(this.tenantsTeams, 0, _.get(this.ticket, 'tenant'))
                                ),
                                team: _.get(
                                    this.editForm,
                                    'tenantsTeamsBrokers.1',
                                    _.get(this.tenantsTeams, 1, _.get(this.ticket, 'team'))
                                ),
                            },
                        })
                        .then((res) => {
                            this.ccsOptions = res.data
                        })
                        .catch((error) => {
                            console.log('remoteMethod error ', error)
                        })
                }, 200)
            } else {
                this.ccsOptions = []
            }
        },
        getTenantTeamBrokers () {
            this.isApi
                .get(`/api/tickets/tenant-team-brokers`)
                .then((res) => {
                    this.tenantsTeamsBrokers = res.data
                })
                .catch((error) => {
                    console.log('getTenantTeamBrokers error ', error)
                })
        },
        async getGithubToken () {
            const octokit = new Octokit({
                authStrategy: createAppAuth,
                auth: {
                    appId: 298611,
                    privateKey: this.githubKey,
                },
            })

            const response = await octokit.auth({
                type: 'installation',
                installationId: 34659992,
            })

            this.githubToken = _.get(response, 'token')
        },
        getGithubMembers (token) {
            this.isApi
                .get(`/api/tickets/${_.get(this.ticket, 'id')}/get-github-members`, {
                    params: {
                        githubToken: token,
                    },
                })
                .then((res) => {
                    this.githubMembers = _.get(res, 'data')
                })
                .catch((error) => {
                    console.log('getGithubMembers error ', error)
                })
        },
        handleConversationTabClick (tab, click) {
            console.log('handleConversationTabClick ', tab, click)
        },
        replyConvo (status = null) {
            if (this.$refs.publicEditor.$refs.quillEditor.quill.getText().trim().length !== 0) {
                this.replyLoading = true

                this.uploadAttachments()

                this.isApi
                    .post(`/api/tickets/${_.get(this.ticket, 'id')}/save-ticket-conversations`, {
                        ...this.reply,
                        isTenant: this.isTenant,
                        status: status
                    })
                    .then((res) => {
                        this.$message({
                            message: 'Replied To ticket Successfully',
                            type: 'success',
                        })

                        this.getConvo()

                        const quillEditor = this.$refs.publicEditor.$refs.quillEditor

                        quillEditor.quill.setText('')

                        this.replyLoading = false
                    })
                    .catch((error) => {
                        console.log('replyConvo error ', error)
                        this.replyLoading = false
                    })
            }
        },
        saveInternalNote () {
            if (this.$refs.internalEditor.$refs.quillEditor.quill.getText().trim().length !== 0) {
                this.replyLoading = true

                this.uploadAttachments()

                this.isApi
                    .post(`/api/tickets/${_.get(this.ticket, 'id')}/save-ticket-internal-notes`, {
                        ...this.notes,
                        isTenant: this.isTenant,
                    })
                    .then((res) => {
                        this.$message({
                            message: 'Internal Notes Saved Successfully',
                            type: 'success',
                        })

                        this.getInternalNotes()

                        const quillEditor = this.$refs.internalEditor.$refs.quillEditor

                        quillEditor.quill.setText('')

                        this.replyLoading = false
                    })
                    .catch((error) => {
                        console.log('internalNote error ', error)
                        this.replyLoading = false
                    })
            }
        },
        getConvo (event) {
            this.isApi
                .get(`/api/tickets/${_.get(this.ticket, 'id')}/ticket-conversations`, {
                    params: {
                        page: _.get(event, 'page', 1),
                        per_page: _.get(event, 'limit', 10),
                    },
                })
                .then((res) => {
                    this.conversations = _.get(res.data, 'data')
                    this.collection = res.data
                    this.conversationCount = _.size(this.conversations)
                })
                .catch((error) => {
                    console.log('getConvo error ', error)
                })
        },
        getInternalNotes (event) {
            this.isApi
                .get(`/api/tickets/${_.get(this.ticket, 'id')}/ticket-internal-notes`, {
                    params: {
                        page: _.get(event, 'page', 1),
                        per_page: _.get(event, 'limit', 10),
                    },
                })
                .then((res) => {
                    this.internalNotes = _.get(res.data, 'data')
                    this.collectionNotes = res.data
                    this.notesCount = _.size(this.internalNotes)
                })
                .catch((error) => {
                    console.log('getConvo error ', error)
                })
        },
        formatDate (date) {
            const utcDate = this.$moment.utc(date).tz(_.get(this.user, 'timezone'))

            if (utcDate.isSame(this.$moment(), 'day')) {
                return utcDate.format('[Today] LT')
            } else if (utcDate.isBetween(this.$moment().startOf('week'), this.$moment().endOf('week'))) {
                return utcDate.format('ddd LT')
            } else if (utcDate.isBetween(this.$moment().startOf('year'), this.$moment().endOf('week'))) {
                return utcDate.format('MMM DD LT')
            } else {
                return utcDate.format('MMM DD YYYY LT')
            }
        },
        async githubIssue (name) {
            this.isApi
                .post(`/api/tickets/${_.get(this.editForm, 'id')}/push-github-issue`, {
                    ...this.editForm,
                    issueAssigned: name,
                    githubToken: this.githubToken,
                })
                .then((res) => {
                    this.$message({
                        message: 'Issue Created In Github Successfully',
                        type: 'success',
                    })
                })
                .catch((error) => {
                    console.log('save error ', error)
                    this.$message({
                        message: 'Error Creating Github Issue',
                        type: 'error',
                    })
                })
        },
        save (status, reply = false) {
            this.$refs.form.validate(async (valid, errors) => {
                if (reply || this.$refs.publicEditor.$refs.quillEditor.quill.getText().trim().length !== 0) {
                    this.replyConvo(status)
                }

                if (valid) {
                    this.updateStatus = status
                    this.loading = true

                    this.uploadAttachments()

                    this.isApi
                        .put(`/api/tickets/${_.get(this.editForm, 'id')}`, {
                            ...this.editForm,
                            selectedAssignee: this.selectedAssignee,
                            selectedRequester: this.selectedRequester,
                            status: status,
                            isTenant: this.isTenant,
                        })
                        .then((res) => {
                            this.$message({
                                message: 'Ticket Updated Successfully',
                                type: 'success',
                            })

                            this.loading = false

                            if (this.isTenant) {
                                window.location = `/admin/account`
                            } else {
                                window.location = `/admin/ticket`
                            }
                        })
                        .catch((error) => {
                            console.log('save error ', error)
                            this.$message({
                                message: 'Error Creating Ticket',
                                type: 'error',
                            })

                            this.loading = false
                        })

                    if (!_.isEmpty(_.get(this.reply, 'body'))) {
                        this.replyConvo()
                    }
                }
            })
        },
        getAssignees () {
            this.isApi
                .get(`/api/tickets/support-developer-brokers`)
                .then((res) => {
                    this.assignees = res.data
                    this.selectedAssignee = _.find(this.assignees, { id: this.editForm.assignee_id })
                        ? _.find(this.assignees, { id: this.editForm.assignee_id })
                        : _.find(this.assignees, { full_name: this.editForm.assignee })
                })
                .catch((error) => {
                    console.log('getAssingees error ', error)
                })
        },
        getRequesters (tenant = null) {
            this.isApi
                .get(`/api/tickets/get-requester`, {
                    params: {
                        tenant: tenant ? tenant : _.get(this.ticket, 'tenant'),
                    },
                })
                .then((res) => {
                    this.requesters = res.data
                    this.selectedRequester = _.find(this.requesters, { id: _.get(this.editForm, 'user_id') })
                        ? _.find(this.requesters, { id: _.get(this.editForm, 'user_id') })
                        : _.find(this.requesters, { full_name: _.get(this.editForm, 'requester') })
                    console.log('getRequesters ', res)
                })
                .catch((error) => {
                    console.log('getRequesters error ', error)
                })
        },
        niceList (list, joiner = 'and', titleCase = false) {
            list = list.slice(0).map((e) => (titleCase ? _.startCase(e) : e))
            if (!Array.isArray(list)) return undefined
            if (list.length === 0) return undefined
            if (list.length === 1) return list.join(', ')
            const lastItem = list.pop()
            return `${list.join(', ')} ${joiner} ${lastItem}`
        },
        loginAs (val) {
            const tenantId = _.get(this.editForm.tenantsTeamsBrokers, 0, _.get(this.ticket, 'tenant', null))
            const tenantUserId = _.get(this.selectedRequester, 'id', _.get(this.ticket, 'user_id', null))

            try {
                let loginUrl = null

                if (tenantId && tenantUserId && val === 'user') {
                    loginUrl = `/admin/auth/sso/tenant/${tenantId}/user/${tenantUserId}`
                } else if (tenantId && val === 'master') {
                    loginUrl = `/admin/auth/sso/tenant/${tenantId}/master`
                }

                if (loginUrl) {
                    this.loginError = null

                    window.open(loginUrl)
                } else {
                    this.loginError = 'No tenant id and/or user id'
                }
            } catch (error) {
                this.$notify({ type: 'error', message: 'Error attempting to login to tenant' })
            }
        },
        onChangeAttachments (event) {
            this.attachments.push(_.get(event, 'raw'))
        },
        removeChangeAttachments (event) {
            _.remove(this.attachments, function (attachments) {
                return attachments.uid !== _.get(event, 'raw.uid')
            })
        },
        ticketAttachments (event) {
            this.isApi(`/api/tickets/${_.get(this.ticket, 'id')}/ticket-attachments`, {
                params: {
                    page: _.get(event, 'page', 1),
                    per_page: _.get(event, 'limit', 10),
                },
            }).then((res) => {
                this.ticketAttachmentData = res.data
                this.fileExtension()
            })
        },
        uploadAttachments () {
            let formData = new FormData()

            for (let i = 0; i < this.attachments.length; i++) {
                formData.append('files[]', this.attachments[i])
            }

            this.isApi.post(`/api/tickets/${_.get(this.ticket, 'id')}/save-ticket-attachments`, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                }
            }).then((res) => {
                this.files = []
                $('#ticket_multiple_files').val('')
                this.ticketAttachments()
            }).catch(error => {
                this.files = []
                $('#ticket_multiple_files').val('')

                this.$message({
                    message: `${_.get(error, 'message')}`,
                    type: 'error',
                })
            })
        },
        downloadAttachemnt (name, url) {
            this.isApi.get(url, { responseType: 'blob' }).then(res => {
                const url = window.URL.createObjectURL(new Blob([res.data]))
                const link = document.createElement('a')
                link.href = url
                link.setAttribute('download', `${name}`)
                document.body.appendChild(link)
                link.click()
            })
        }
    },
}
</script>

<style>
.ticket-attachment {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    max-width: 12ch;
}

.border-design {
    border: 1px solid #409EFF;
    display: flex;
    border-radius: 4px;
}

</style>
